import { useQuery } from "@apollo/client";
import { Box, Paper, Typography } from "@mui/material";
import { GET_STAFF_CERS_TRUE_UP_SUBMITTALS_COUNT } from "hooks/useStaffCersTrueUpSubmittals";
import { GET_STAFF_CERS_UNMATCHED_EXPANSION } from "hooks/useStaffCersUnmatchedExpansion";
import { KeyMetric } from "routes/Staff/Fulfillment/WorkflowOverviewStats/KeyMetric";

export function CoverageStatCards() {
  const { data, loading } = useQuery(GET_STAFF_CERS_UNMATCHED_EXPANSION, {
    fetchPolicy: "cache-and-network",
  });
  const { data: trueUp, loading: trueUpLoading } = useQuery(
    GET_STAFF_CERS_TRUE_UP_SUBMITTALS_COUNT,
    { fetchPolicy: "cache-and-network" }
  );
  const stats = data?.staffCersUnmatchedExpansion.stats;
  const outOfBand = trueUp?.staffCersTrueUpSubmittals.count;
  return (
    <Paper elevation={0} sx={{ px: 3, py: 2.5 }}>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ mb: 1.5, display: "block", fontWeight: 600, textTransform: "uppercase" }}
      >
        Coverage
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "repeat(2, 1fr)", md: "repeat(4, 1fr)" },
          gap: 1.5,
        }}
      >
        <KeyMetric name="Out-of-band · 12mo" value={outOfBand} loading={trueUpLoading} />
        <KeyMetric name="Unmatched facilities" value={stats?.unmatchedTotal} loading={loading} />
        <KeyMetric name="Tenants with gaps" value={stats?.tenantsWithGaps} loading={loading} />
        <KeyMetric name="Net-new / unattributed" value={stats?.netNewTotal} loading={loading} />
      </Box>
    </Paper>
  );
}
